import React, { useState } from 'react';
import { Box, Button, Menu, Typography } from '@mui/material';
import newGroup from '../images/newGroup.png'
import { Select } from '.';
import InputField from './InputField';
import PrimaryButton from './PrimaryButton';

const AddGroup = ({ createGroup, groups, showImage }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [type, setType] = useState();
    const [number, setNumber] = useState();
    const [error, setError] = useState();

    const validateGroup = () => {
        const newGroup = `${type}-${number}`
        if (!number || number < 0 || !type) return setError('Invalid group format');
        if (groups.includes(newGroup)) return setError('Group already exists');
        createGroup({ name: newGroup })
        setAnchorEl(null)
    }

    return <Box>
        <Button variant="outlined" className="secondary-button" onClick={(event) => setAnchorEl(event.currentTarget)}>
            ADD GROUP
        </Button>
        <Menu
            elevation={5}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id="add-group"
            anchorEl={anchorEl}
            style={{ borderRadius: '7px' }}
            open={Boolean(anchorEl)}
            onClose={(event) => setAnchorEl(null)}
        >
            <Box minHeight='10em' minWidth='35em' display='flex' justifyContent='start'>
                {showImage &&
                    <Box padding='1rem 3rem' display='flex' flexDirection='column' justifyContent='center'>
                        <Box>
                            <img src={newGroup} className="newGroup" alt="newGroup" style={{ height: '10em' }} />
                        </Box>
                    </Box>
                }
                <Box padding='1rem 3rem'>
                    <Typography align='center' whiteSpace={true}>New Group is going to be ...</Typography>
                    <Box>
                        <Select
                            label='Group type'
                            value={type}
                            error={Boolean(error)}
                            onChange={(e) => setType(e.target.value)} options={[
                                { value: 'FREE', label: 'Free' },
                                { value: 'QA', label: 'QA' },
                                { value: 'JS', label: 'JavaScript' },
                                { value: 'AUTO', label: 'Automation' },
                                { value: 'REACT', label: 'React' },
                            ]}
                        />
                        <InputField label='Group number'
                            value={number}
                            onChange={event => setNumber(event.target.value)}
                            type='number'
                            error={error}
                            containerStyle={{ marginBottom: '1em' }} />
                        <PrimaryButton fullWidth={true} onClick={() => validateGroup()}>Add</PrimaryButton>
                    </Box>
                </Box>
            </Box>
        </Menu>
    </Box>
}

export default AddGroup